import { render } from "./Uoms.vue?vue&type=template&id=1cf74666"
import script from "./Uoms.vue?vue&type=script&setup=true&lang=js"
export * from "./Uoms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-submission/components/filter/Uoms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cf74666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cf74666', __exports__)) {
    api.reload('1cf74666', __exports__)
  }
  
  module.hot.accept("./Uoms.vue?vue&type=template&id=1cf74666", () => {
    api.rerender('1cf74666', render)
  })

}


export default __exports__